export const GOOGLE_MAPS_KEY = 'AIzaSyDsAjuK6KM7q4k3I6HAwMPYcTaYVxeghhI';
